/*
 * @Author: cyerogy cyerogy@163.com
 * @Date: 2025-04-04 10:05:23
 * @LastEditors: cyerogy cyerogy@163.com
 * @LastEditTime: 2025-04-05 21:00:13
 * @FilePath: \projectorder\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 1. 导入创建路由对象 和 创建hash对象
import { createRouter, createWebHashHistory } from 'vue-router';

// 3. 配置路由映射关系表
const constantRoutes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/list"),
  },
  // 路径和组件映射起来
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/user/login"),
  },
  {
    path: "/:catchAll(.*)",
    component: () => import("@/views/404"),
    hidden: true,
  }
];

// 4. 创建路由对象
const createRouterInstance = () =>
  new createRouter({
    // 5. 配置路由跳转模式，这里使用 hash 模式
    history: createWebHashHistory(),
    base: process.env.BASE_URL,
    // 把映射表放入
    routes: constantRoutes
  })

const router = createRouterInstance();


export function resetRouter() {
  const newRouter = createRouterInstance();
  router.matcher = newRouter.matcher; // reset router
}
// 5. 导出
export default router;